import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  tripleSelectContainer: {
    marginBottom: '0 !important',
    '& > div': {
      marginBottom: 10,
    },
  },
}));
